import { Swiper, Navigation } from "../global/swiper.js";

export function carouselDirectory() {
  const container = document.querySelector(".directory-carousel");
  if (!container) return;

  const swiper = new Swiper(container, {
    modules: [Navigation],
    loop: true,
    slidesPerView: 1,
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
    navigation:
      {
        nextEl: document.querySelector(".btn-next"),
        prevEl: document.querySelector(".btn-prev"),
      },
  });
}
